// src/layout/Layout.jsx
import React, { Suspense, useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import FloatingLanguageButton from "../components/FloatingLanguageButton";

const Footer = React.lazy(() => import("./Footer"));

export default function Layout({ wrappedComponents, children }) {
  const location = useLocation();
  const mainRef = useRef(null);

  useEffect(() => {
    if (mainRef.current) mainRef.current.focus({ preventScroll: true });
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const content = wrappedComponents ?? children;

  return (
    <>
      <Helmet>
        <meta name="theme-color" content="#18367e" />
        <meta name="apple-mobile-web-app-status-bar-style" content="default" />
        <meta name="color-scheme" content="light" />
        {/* Clamp horizontal overflow app-wide (scoped, non-invasive) */}
        <style>{`
          html, body, #root { max-width: 100%; overflow-x: hidden; }
        `}</style>
      </Helmet>

      {/* Wrap everything to ensure no child can push the body width */}
      <div className="w-full overflow-x-hidden">
        {/* Header above any Google banner */}
        <div style={{ position: "relative", zIndex: 10000000 }}>
          <Header />
        </div>

        <main
          id="main-content"
          ref={mainRef}
          tabIndex={-1}
          role="main"
          className="w-full overflow-x-hidden"
        >
          {content}
        </main>

        <Suspense
          fallback={
            <div
              aria-hidden="true"
              className="h-[120px] w-full bg-[#18367e] border-t-4 border-[#f9b806]"
            />
          }
        >
          <Footer />
        </Suspense>

        <FloatingLanguageButton />

        <noscript>
          <div
            style={{
              padding: "1rem",
              textAlign: "center",
              background: "#18367e",
              color: "white",
            }}
          >
            For the full experience, please enable JavaScript. Core content is still accessible.
          </div>
        </noscript>
      </div>
    </>
  );
}
